export function includeWhen(shouldInclude, component) {
  return shouldInclude ? component() : null;
}

export default includeWhen;
